import { apiClient } from './apiClient';
export interface AdSticker { id: string; name: string; imageUrl: string }
export const adStickerService = {
  list: () => apiClient.get<AdSticker[]>('/ad-stickers'),
  create: (name: string, imageUrl: string) => apiClient.post<AdSticker>('/ad-stickers', { name, imageUrl }),
  rename: (id: string, name: string) => apiClient.patch<AdSticker>(`/ad-stickers/${id}`, { name }),
  remove: (id: string) => apiClient.delete<void>(`/ad-stickers/${id}`),
  upload: async (file: File) => {
    const form = new FormData();
    form.append('file', file);
    form.append('source', 'AD_STICKER');
    const result = await apiClient.post<{ success: boolean; url: string }>('/media/upload', form, { headers: { 'Content-Type': 'multipart/form-data' } });
    if (!result.success || !result.url) throw new Error('Upload failed');
    return result.url;
  },
};
